import { IProduct } from "../declarations/product";

export class LoadSettings {
    static readonly type = '[Settings] Load Settings';
    constructor() { }
}
export class SelectProduct {
    static readonly type = '[Product] Select Product';
    constructor(public selectedProduct: IProduct) { }
}